import React, { useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Divider,
  Col,
  Form,
  Checkbox,
  Row,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApi } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSupplier } from '../../../network/supplier';
import { getSearchPatients } from '../../../network/appointment';
const ItemListStock = ({
  setDataSourceItem,
  dataSourceItem,
  t,
  form,
  currentLang,
}) => {
  const [searchTextAccount, setSearchTextAccount] = useState('');
  const [searchTextWarehouse, setSearchTextWarehouse] = useState('');
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [searchTextPriceList, setSearchTextPriceList] = useState('');
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getAccountSearch],
    queryFn: () => getSearchPatients('Account', searchTextAccount),
    keepPreviousData: true,
    enabled: searchTextAccount?.length >= 3 || searchTextAccount?.length === 0,
  });
  const { data: Warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouseSearch],
    queryFn: () => getSearchPatients('Warehouse', searchTextWarehouse),
    keepPreviousData: true,
    enabled:
      searchTextWarehouse?.length >= 3 || searchTextWarehouse?.length === 0,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchPatients('Cost Center', searchTextCostCenter),
    keepPreviousData: true,
    enabled:
      searchTextCostCenter?.length >= 3 || searchTextCostCenter?.length === 0,
  });
  const { data: suppliers } = useQuery({
    queryKey: [queryKeys.getSupplier],
    queryFn: () =>
      getSupplier({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch],
    queryFn: () => getSearchPatients('Price List', searchTextPriceList),
    keepPreviousData: true,
    enabled:
      searchTextPriceList?.length >= 3 || searchTextPriceList?.length === 0,
  });
  const [count, setCount] = useState(0);
  const watchEnableDeferredRevenue = Form.useWatch(
    'enable_deferred_revenue',
    form
  );
  const watchNoOfMonths = Form.useWatch('enable_deferred_expense', form);

  const columns = [
    {
      title: t.warehouse,
      dataIndex: 'default_warehouse',
      render: (text, record, index) => (
        <Select
          placeholder={t.warehouse}
          showSearch
          popupMatchSelectWidth={false}
          value={record.default_warehouse}
          optionFilterProp="children"
          filterOption={false}
          onSearch={(value) => {
            setSearchTextWarehouse(value);
          }}
          options={Warehouse?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              default_warehouse: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.PriceList,
      dataIndex: 'default_price_list',
      render: (text, record, index) => (
        <Select
          placeholder={t.PriceList}
          popupMatchSelectWidth={false}
          showSearch
          value={record.default_price_list}
          optionFilterProp="children"
          filterOption={false}
          onSearch={(value) => {
            setSearchTextPriceList(value);
          }}
          options={priceList?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
            option: item,
          }))}
          onChange={(value) => {
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              default_price_list: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.discountAccount,
      dataIndex: 'default_discount_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.discountAccount}
          popupMatchSelectWidth={false}
          showSearch
          value={record.default_discount_account}
          optionFilterProp="children"
          filterOption={false}
          onSearch={(value) => {
            setSearchTextAccount(value);
          }}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            setSearchTextAccount('');
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              default_discount_account: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.buyingCostCenter,
      dataIndex: 'buying_cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.buyingCostCenter}
          popupMatchSelectWidth={false}
          showSearch
          value={record.buying_cost_center}
          optionFilterProp="children"
          filterOption={false}
          onSearch={(value) => {
            setSearchTextCostCenter(value);
          }}
          options={costCenters?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            setSearchTextAccount('');
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              buying_cost_center: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.sellingCostCenter,
      dataIndex: 'selling_cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.sellingCostCenter}
          popupMatchSelectWidth={false}
          showSearch
          optionFilterProp="children"
          filterOption={false}
          value={record.selling_cost_center}
          onSearch={(value) => {
            setSearchTextCostCenter(value);
          }}
          options={costCenters?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            setSearchTextCostCenter('');
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              selling_cost_center: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.Supplier,
      dataIndex: 'default_supplier',
      render: (text, record, index) => (
        <Select
          placeholder={t.Supplier}
          showSearch
          popupMatchSelectWidth={false}
          value={record.default_supplier}
          optionFilterProp="children"
          filterOption={false}
          // onSearch={(value) => {
          //   setSearchText(value);
          // }}
          options={suppliers?.data?.map((item) => ({
            value: item?.supplier_name,
            // item?.[
            //   currentLang === 'en'
            //     ? 'supplier_name'
            //     : 'supplier_name_in_arabic'
            // ],
            label: item?.name,
          }))}
          onChange={(value) => {
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              default_supplier: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.expenseAccount,
      dataIndex: 'expense_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.expenseAccount}
          showSearch
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          value={record.expense_account}
          filterOption={false}
          onSearch={(value) => {
            setSearchTextAccount(value);
          }}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            setSearchTextAccount('');
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              expense_account: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.incomeAccount,
      dataIndex: 'income_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.incomeAccount}
          popupMatchSelectWidth={false}
          showSearch
          value={record.income_account}
          optionFilterProp="children"
          filterOption={false}
          onSearch={(value) => {
            setSearchTextAccount(value);
          }}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          onChange={(value) => {
            setSearchTextAccount('');
            const newDataSource = [...dataSourceItem];
            newDataSource[index] = {
              ...newDataSource[index],
              income_account: value,
            };
            setDataSourceItem(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      uom: '',
      conversion_factor: '',
    };
    setDataSourceItem((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceItem.filter((item) => item.key !== key);
    setDataSourceItem(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceItem}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <Divider />
      <Row gutter={16}>
        <Col sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            name="enable_deferred_expense"
            label={t.enableDeferredExpense}
            valuePropName="checked"
            layout="horizontal"
          >
            <Checkbox />
            {/* <Checkbox>{t.deferredExpense}</Checkbox> */}
          </Form.Item>
        </Col>
        <Col sm={12} md={12} lg={12} xl={12}>
          <Form.Item
            name="enable_deferred_revenue"
            label={t.enableDeferredRevenue}
            valuePropName="checked"
            layout="horizontal"
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        {watchNoOfMonths ? (
          <Col sm={12} md={12} lg={12} xl={12}>
            <Form.Item name="no_of_months_exp" label={t.noOfMonthsOfExpense}>
              <Input
                type="number"
                min={0}
                placeholder={t.noOfMonthsOfExpense}
              />
            </Form.Item>
          </Col>
        ) : null}
        {watchEnableDeferredRevenue ? (
          <Col sm={12} md={12} lg={12} xl={12}>
            <Form.Item name="no_of_months" label={t.noOfMonths}>
              <Input placeholder={t.noOfMonths} />
            </Form.Item>
          </Col>
        ) : null}
      </Row>
    </Card>
  );
};

export default ItemListStock;
